import TopNav from './landing/sections/TopNav';
import Hero from './landing/sections/Hero';
import ModuleShowcase from './landing/sections/ModuleShowcase';
import Pricing from './landing/sections/Pricing';
import WhyChooseUs from './landing/sections/WhyChooseUs';
import Testimonials from './landing/sections/Testimonials';
import FAQ from './landing/sections/FAQ';
import LandingFooter from './landing/sections/LandingFooter';
import FloatingContactButtons from './landing/sections/FloatingContactButtons';

/**
 * Public marketing page for the HRMS + Payroll product. Composed of
 * focused section components under `./landing/sections/`. All copy is
 * driven by the `landing` i18n namespace (en + hi).
 *
 * Mounted both at `/` (default homepage) and `/landing` (legacy alias).
 */
export default function Landing() {
  return (
    <div className="min-h-screen bg-[var(--color-bg-app)] text-[var(--color-text-primary)]">
      <TopNav />
      <main>
        <Hero />
        <ModuleShowcase />
        <Pricing />
        <section id="why-us">
          <WhyChooseUs />
        </section>
        <Testimonials />
        <section id="faq">
          <FAQ />
        </section>
      </main>
      <LandingFooter />
      {/* Sticky bottom-right cluster — Free trial CTA + WhatsApp +
          Call + scroll-to-top. Stays anchored as the visitor scrolls
          through every section. */}
      <FloatingContactButtons />
    </div>
  );
}
